// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"80118531","551":"d27c7836","851":"f9289b2a"}[chunkId] + ".chunk.js";
};